// extracted by mini-css-extract-plugin
export default {"drawer":"drawer_drawer__yL3-M","userChip":"drawer_userChip__8++-v"};